import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { useQueryParamsWithProducts } from "functions/queryParamFuncs";

const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [queryParams, _] = useQueryParamsWithProducts([-1]);
  const [selectedProductIds, setSelectedProductIds] = useState(
    queryParams.products
  );

  const setSelectedProductIdsMemoized = useCallback(setSelectedProductIds, []);

  const contextValue = useMemo(
    () => ({
      selectedProductIds,
      setSelectedProductIds: setSelectedProductIdsMemoized,
    }),
    [selectedProductIds]
  );

  return (
    <ProductContext.Provider value={contextValue}>
      {children}
    </ProductContext.Provider>
  );
};

export const useProduct = () => useContext(ProductContext);
